import React from "react";
import { cn } from "@/lib/utils";

export default function CornerSvg({
  className,
  fill = "currentColor",
}: {
  className?: string;
  fill?: string;
}) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden="true"
    >
      <g clipPath="url(#corner-clip)">
        <path
          d="M-47.9805 -76C-21.4709 -76 0.0194701 -54.5096 0.0194702 -28V-0.00976562C0.0194702 17.6633 14.3464 31.9902 32.0195 31.9902H1794C1840.39 31.9904 1878 69.5984 1878 115.99V2080C1878 2126.4 1840.39 2164 1794 2164H-302C-348.392 2164 -385.998 2126.4 -385.998 2080V-28C-385.998 -54.5096 -364.508 -76 -337.998 -76H-47.9805Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="corner-clip">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
